<template>
  <div v-if="!Boolean(data.followFlg)" @click="follow" class="action">フォロー</div>
  <div v-else-if="Boolean(loginFlg)" class="unfollow">
    <span @click="unFollow">フォロー解除</span>
    <span>フォロー中</span>
  </div>
  <div v-else ></div>
</template>
<script setup>
import axios from 'axios'
import Global from '../js/constant.js'
import { computed, defineProps, onMounted, reactive, watch } from 'vue'
import { useStore } from 'vuex'
import { useToast } from 'vue-toast-notification'

const $store = useStore()
const $toast = useToast()

// props
const props = defineProps({
  followAccountId : {
    type: Number,
    required: false
  }  
})

// state
const data = reactive({
  followFlg : false,
  followId : null,
})

// mapstate
const account = computed(() => $store.state.core.account)
const accountFollows = computed(() => $store.state.follows.accountFollows)
const loginFlg = computed(() => $store.state.core.loginFlg)

// mapmutation
const setAccountFollows = (val) => $store.commit('setAccountFollows', val)
const setClientErrors = (val) => $store.commit('setClientErrors', val)

onMounted(() => {
  initState(accountFollows.value)
})

// watch
watch(accountFollows, (newVals) => {
  initState(newVals)
})

// methods
const initState = (accountFollows) => {
  let target = accountFollows.filter(r => r.follow_account_id === props.followAccountId)
  data.followFlg = target.length > 0
  if (target.length > 0) data.followId = target[0].id
}

const follow = async () => {
  let params = {
    account_id : account.value.id,
    follow_account_id : props.followAccountId,
  }
  await axios.post(Global.url.api_account_follows_create, params)
  .then(res => {
    if(res.data.status == Global.api_status.success){
      data.followId = res.data.account_follow.id
      data.followFlg = true
      $toast.success("success")
      let newFollows = accountFollows.value.concat([res.data.account_follow])
      setAccountFollows(newFollows)
      return
    }
  }).catch(error => {
    $toast.error('client error common/LabelAccountFollow.vue::follow')
    setClientErrors({
      func:"common/LabelAccountFollow.vue::follow",
      params: {
        account_id : account.value.id,
        follow_account_id : props.followAccountId,
      },
      errorMessage:error
    })
  })
}

const unFollow = async () => {
  await axios.delete(Global.url.api_account_follows_delete + "/" + data.followId)
  .then(res => {
    if (res.data.status === Global.api_status.success) {
      let newFollows = accountFollows.value.filter(r => r.id !== data.followId)
      setAccountFollows(newFollows)
      data.followId = null
      data.followFlg = false
      $toast.success("success")
      return
    }
  }).catch(error=>{
    $toast.error('client error')
    setClientErrors({func:"common/label-account-follow.vue::unFollow", params: {id:this.followId}, errorMessage:error})
  })
}
</script>
<!-- <script>
import { mapState, mapMutations } from 'vuex'
import _ from 'lodash'
import account_follows from '../../js/api/account-follows'

export default {
  props : {
    followAccountId : {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      followFlg : false,
      followId : null,
    }
  },
  computed: {
    ...mapState([
      'loginFlg',
      'account',
      'accountFollows',
    ])
  },
  watch: {
    accountFollows (newVals) {
      this.initState(newVals)
    }
  },
  created : function () {
    this.initState(this.accountFollows)
  },
  methods : {
    ...mapMutations([
      'setAccountFollows',
      'setClientErrors',
    ]),
    initState : function (accountFollows) {
      let target = _.filter(accountFollows, r => r.follow_account_id === this.followAccountId)
      this.followFlg = target.length > 0
      if (target.length > 0) this.followId = target[0].id
    },
    follow : function () {
      let ret = account_follows.create(this.account.id, this.followAccountId)
      ret.then(res => {
        if(res.data.status == this.Global.api_status.success){
          this.followId = res.data.account_follow.id
          this.followFlg = true
          this.$toasted.success("success")
          let newFollows = this.accountFollows.concat([res.data.account_follow])
          this.setAccountFollows(newFollows)
          return
        }
        // console.dir(res.data.errors)
        // this.$toasted.error("failed")
      }).catch(error=>{
        this.$toasted.error('client error')
        this.setClientErrors({
          func:"common/label-account-follow.vue::follow",
          params: {
            account_id : this.account.id,
            follow_account_id : this.followAccountId,
          },
          errorMessage:error
        })
      })
    },

    unFollow : function () {
      let ret = account_follows.delete(this.followId)
      ret.then(res => {
        if (res.data.status === this.Global.api_status.success) {
          let newFollows = _.filter(this.accountFollows, r => r.id !== this.followId)
          this.setAccountFollows(newFollows)
          this.followId = null
          this.followFlg = false
          this.$toasted.success("success")
          return
        }
        // console.dir(res.data.errors)
        // this.$toasted.error("failed")
      }).catch(error=>{
        this.$toasted.error('client error')
        this.setClientErrors({func:"common/label-account-follow.vue::unFollow", params: {id:this.followId}, errorMessage:error})
      })
    }
  }
}
</script> -->